import { createRoot } from 'react-dom/client';
import '@fontsource-variable/nunito';
import './styles.css';
import { App } from './App';
import { config } from './config';
import { initTelemetry } from './services/telemetry';
import { useShell } from './state/shell';

initTelemetry(__APP_VERSION__);

if (!config.apiBaseUrl || !config.firebase.apiKey) {
  console.warn('EthrHunt is missing VITE_API_BASE_URL / VITE_FIREBASE_* configuration; see web/.env.example');
}

createRoot(document.getElementById('root')!).render(<App />);

// Offer updates instead of reloading mid-hunt.
if ('serviceWorker' in navigator) {
  void import('virtual:pwa-register').then(({ registerSW }) => {
    const update = registerSW({
      onNeedRefresh() {
        useShell.getState().setUpdate(() => void update(true));
      },
    });
  });
}
